// ** React imports 
import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Layout Imports
// !Do not remove this Layout import
import Layout from '../core/layouts/Layout'

// ** Navigation Imports
import VerticalNavItems from '../navigation/vertical'


import HorizontalAppBarContent from './components/horizontal/AppBarContent'

// ** Hook Import
import { useSettings } from '../core/hooks/useSettings'
import { useAuth } from 'hooks/useAuth'

const UserLayout = ({ children }) => {
  // ** Hooks
  const { settings, saveSettings } = useSettings()
  const { pricingAccess } = useAuth()

  /**
   *  The below variable will hide the current layout menu at given screen size.
   *  The menu will be accessible from the Hamburger icon only (Vertical Overlay Menu).
   *  You can change the screen size from which you want to hide the current layout menu.
   *  Please refer useMediaQuery() hook: https://mui.com/material-ui/react-use-media-query/,
   *  to know more about what values can be passed to this hook.
   *  ! Do not change this value unless you know what you are doing. It can break the template.
   */
  const hidden = useMediaQuery(theme => theme.breakpoints.down('md'))

  return (
    <Layout
      hidden={hidden}
      settings={settings}
      saveSettings={saveSettings}
      {...({

        // ** Navigation Items
        verticalNavItems: VerticalNavItems().filter(item => item.title !== 'Sync Price Books' || pricingAccess),

        // ** AppBar Content
        horizontalAppBarContent: (props) => (
          <HorizontalAppBarContent
            hidden={hidden}
            settings={settings}
            saveSettings={saveSettings}
            toggleNavVisibility={props.toggleNavVisibility}
          />
        )
      })}
    >
      {children}
    </Layout>
  )
}

export default UserLayout
